<template>
  <div class="grid" :style="{ gridTemplateColumns }">
    <div
      v-for="document in value"
      class="document clickable"
      @click="selectItem(document)"
      :key="document.localTmpId"
    >
      <v-chip
        v-if="document.isNew"
        class="ma-1"
        style="position: absolute; z-index: 2"
        color="success"
        dark
        x-small
        >New</v-chip
      >
      <div class="fileInfo caption">
        {{ document.filename }}
      </div>
      <div v-if="isPdf(document)" class="full-height">
        <div class="cover"></div>
        <embed width="100%" height="100%" :src="document.src" />
      </div>
      <v-img
        v-else-if="isImage(document)"
        class="ma-2"
        :src="document.thumbnail"
        aspect-ratio="1"
        contain
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <div v-else>
        <v-icon style="transform: scale(0.8)" :size="itemSize">mdi-file</v-icon>
      </div>
      <v-icon class="remove-button" @click.stop="removeItem(document)">mdi-close-circle</v-icon>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    itemSize: {
      type: String,
      default: '185px',
    },
  },
  data() {
    return {};
  },
  computed: {
    gridTemplateColumns() {
      return `repeat(auto-fit, ${this.itemSize})`;
    },
  },
  methods: {
    get,
    removeItem(item) {
      this.$emit('remove', item);
    },
    selectItem(item) {
      this.$emit('select', item);
    },
    isPdf(file) {
      return file.contentType === 'application/pdf';
    },
    isImage(file) {
      const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return validImageTypes.includes(file.contentType);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  gap: 40px;
  padding: 0 8px;
  align-content: start;
  .document {
    border: 1px solid #ddd;
    aspect-ratio: 1/1;
    position: relative;
    .fileInfo {
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 4px;
      text-align: right;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(1px);
    }
    .cover {
      height: 100%;
      width: 100%;
      position: absolute;
    }
    .remove-button {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(50%, -50%);
    }
  }
}
</style>
